import { useContext } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';

export default function useEffectiveMake(): string {
  const { customizeOptions, modelVersions, trims, truckBodyStyles, years } =
    useContext(ParentModelContext);

  const customizedTrim = customizeOptions.data;
  const truckBodyStyleData = truckBodyStyles.data;

  return (
    customizedTrim.make ||
    truckBodyStyleData.make ||
    trims.data.make ||
    modelVersions.data.make ||
    years.make
  );
}
